export const injectGtmScript = (dataLayer: string, id: string): Array<unknown> => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  window[dataLayer] = window[dataLayer] || [];
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
  window[dataLayer].push({
    'gtm.start':
      new Date().getTime(),
    event: 'gtm.js',
  });
  const f = document.getElementsByTagName('script')[0];
  const j = document.createElement('script');
  const dl = dataLayer !== 'dataLayer' ? `&l=${dataLayer}` : '';
  j.async = true;
  j.src = `https://www.googletagmanager.com/gtm.js?id=${id}${dl}`;
  f.parentNode?.insertBefore(j, f);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return window[dataLayer];
};
